import InHouseIndex from "@/views/in-house/InHouseIndex.vue";

const inHouse = [
  {
    path: "/in-house",
    name: "inHouse",
    component: InHouseIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default inHouse;
